module.exports = __webpack_public_path__ + "static/media/3DPPA23.2014dff0.jpg";